{
  "language": {
    "name": "English",
    "choose": "Language",
    "reviewed": "no",
    "unreviewedNotice": "This English interface is an unreviewed placeholder translation. Record content is always shown as it was written."
  },
  "app": {
    "name": "Continuum",
    "banner": "STANDBY RECORD"
  },
  "nav": {
    "ward": "Ward list",
    "search": "Find patient",
    "register": "New patient"
  },
  "status": {
    "checking": "Checking …",
    "ready": "Database connected",
    "aliveNoDatabase": "API responding, database unavailable",
    "unreachable": "API not responding"
  },
  "action": {
    "openPatient": "Open the patient overview for {name}"
  },
  "value": {
    "notRecorded": "Not recorded",
    "unreadable": "Cannot be displayed"
  },
  "identity": {
    "nameMissing": "Name missing",
    "age": "{years} yrs"
  },
  "safety": {
    "allergyActive": "Allergy",
    "allergyUnknown": "Allergy not assessed",
    "allergyNoneKnown": "No known allergies",
    "allergyUndocumented": "Allergy not documented",
    "dnr": "DNR",
    "isolation": "Isolation: {type}",
    "estimatedIdentity": "Not identified",
    "confidentialityMarked": "Protected identity",
    "deceased": "Deceased"
  },
  "deployment": {
    "internetDemo": "Test environment on the internet. Never enter real patient details — everything here is made up, and what you write can be read by others who are testing."
  }
}
